import React from "react";
import logo from "./vitalteams-logo.png";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0, 0, 5, 0),
    padding: theme.spacing(3, 0, 0, 0),
  },
  logoImage: {
    width: "25%",
  },
}));
const Header: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src={logo} alt="Vital Teams Logo" className={classes.logoImage} />{" "}
      <hr />
    </div>
  );
};

export default Header;
